import {useContext, useState,} from "react";
import {EditContext} from "../../../misc/scroller/EditProvider";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import moment, {Moment} from "moment";
import {StaticDatePicker} from "@mui/x-date-pickers";
import {useNavigate} from "react-router-dom";
import {useSyncedRef} from "../../../misc/SyncedRef";

export function CreateRoute(props: {
    onDone(): void;
}) {
    const nav = useNavigate();

    const ctx = useContext(EditContext);
    const [date, setDate] = useState<Moment|null>(moment.utc().startOf("day"));
    const dateRef = useSyncedRef(date);

    const run = useAsyncAction(async () => {
        const value = await api.logistics.updateRoute({
            date: dateRef.current,
        } as any);

        await ctx.reload();

        ctx.onSelect.emit({
            id: value.id,
            index: 100,
            value: value,
            editing: false,
        })

        nav("/logistics/route/" + value.id);

    }, []);

    const submit = () => {
        run.callback({});
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>
                Create Route
            </DialogTitle>
            <DialogContent>
                <div style={{height: 4}} />
                <StaticDatePicker
                    displayStaticWrapperAs="desktop"
                    value={date}
                    onChange={(newValue) => {
                        setDate(newValue ? newValue.startOf("day") : null);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                />
            </DialogContent>
            <SmoothActionBar
                loading={run.loading}
                error={run.error}
                actionName="Submit"
                submitDisabled={!date}
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}